import { createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

const inventoryLineItemSlice = createSlice({
  name: "inventoryLineItems",
  initialState: [],
  reducers: {
    setItems: (state, action) => {
      return action.payload;
    },
    addItem: (state, action) => {
      state.push({ id: uuidv4(), ...action.payload });
    },
    updateItem: (state, action) => {
      const index = state.findIndex((item) => item.id === action.payload.id);
      if (index !== -1) {
        state[index] = action.payload;
      }
    },
    deleteItem: (state, action) => {
      return state.filter((item) => item.id !== action.payload);
    },
  },
});

export const { setItems, addItem, updateItem, deleteItem } =
  inventoryLineItemSlice.actions;
export default inventoryLineItemSlice.reducer;
